// extracted by mini-css-extract-plugin
export var content = "_ax-3";
export var list = "_ax-4";
export var settingsContent = "_ax-7";
export var settingsPanel = "_ax-8";
export var state = "_ax-6";
export var triggerBadge = "_ax-2";
export var triggerButton = "_ax-1";
export var triggerShell = "_ax-0";
export var unreadDot = "_ax-5";